import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=3827b10a&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=3827b10a&prod&scoped=true&lang=css"
import style1 from "./Customer.vue?vue&type=style&index=1&id=3827b10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827b10a",
  null
  
)

export default component.exports